var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26086 12.155V17.0192C3.26086 21.8834 5.21086 23.8334 10.075 23.8334H15.9142C20.7784 23.8334 22.7284 21.8834 22.7284 17.0192V12.155",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C14.9825 13 16.445 11.3859 16.25 9.40335L15.535 2.16669H10.4758L9.74999 9.40335C9.55499 11.3859 11.0175 13 13 13Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8359 13C22.0242 13 23.6275 11.2234 23.4109 9.04585L23.1075 6.06669C22.7175 3.25002 21.6342 2.16669 18.7959 2.16669H15.4917L16.25 9.76085C16.4342 11.5484 18.0484 13 19.8359 13Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10999 13C7.8975 13 9.51166 11.5484 9.68499 9.76085L9.92333 7.36669L10.4433 2.16669H7.13916C4.30083 2.16669 3.21749 3.25002 2.82749 6.06669L2.53499 9.04585C2.31833 11.2234 3.92166 13 6.10999 13Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.4167C11.1908 18.4167 10.2916 19.3159 10.2916 21.125V23.8334H15.7083V21.125C15.7083 19.3159 14.8091 18.4167 13 18.4167Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.cf2b15bb6c69d979ef6088b84b5a3cc1.svg";
export { ForwardRef as ReactComponent };